export default __webpack_public_path__ + "static/media/ico_14.df5ec724.png";